module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SZNS","short_name":"SZNS","start_url":"/","background_color":"#131710","theme_color":"#131710","display":"standalone","icon":"src/images/icons/marketing/szns_logo_favicon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"99475ea7dca6809c86a96b8daa09b907"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
